const navItems = [
    { id: 1, href: "#user-roles", icon: "fa fa-user-tag", label: "User Roles"},
    { id: 2, href: "#users", icon: "fa fa-user", label: "System Users"},
    { id: 3, href: "#permissions", icon: "fa fa-shield-halved", label: "Permissions"},
    { id: 4, href: "#school-profile", icon: "fa fa-briefcase", label: "School Profile"},
    { id: 5, href: "#preferences", icon: "fa fa-globe", label: "Preferences" },
    { id: 6, href: "#class-level", icon: "fas fa-bookmark", label: "Class Levels"},
    { id: 7, href: "#classes", icon: "fas fa-school", label: "Classes & Streams"},
    { id: 8, href: "#terms", icon: "fa fa-calendar", label: "Academic Terms"},
    { id: 10, href: "#assessment", icon: "fas fa-edit", label: "Assessments"},
    { id: 11, href: "#period", icon: "fas fa-clock", label: "Current Period"},
    { id: 12, href: "#subjects", icon: "fas fa-book", label: "Subjects"},
    { id: 13, href: "#houses", icon: "fas fa-house", label: "School Houses"},
    { id: 14, href: "#reports", icon: "fas fa-comment", label: "Report Comments"},
    { id: 16, href: "#api", icon: "fa fa-external-link", label: "External Interfaces"},
    { id: 17, href: "#keys", icon: "fa fa-key", label: "System Keys"},



];

export default navItems;
